import React, { FC } from 'react';
import BookingCoverme, { BookingCovermeProps } from './BookingCoverme';

const BookingCovermeClient: FC<Partial<BookingCovermeProps>> = (props) => {
  return <BookingCoverme {...(props as BookingCovermeProps)} forceMode="client" />;
};

export default BookingCovermeClient;
